
<script>
import New from './New5'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
